// Entry point for the site's scripts, bundled to public/assets/js/main.js.
import { initHeader } from './modules/header.js'
import { initMosaic } from './modules/mosaic.js'
import { initFilters } from './modules/filter.js'
import { initTabs } from './modules/tabs.js'
import { initSliders } from './modules/slider.js'
import { initGoogleReviews } from './modules/google-reviews.js'
import { initMarquees } from './modules/marquee.js'
import { initFormPresets } from './modules/form-presets.js'
import { initJumpNav } from './modules/jump-nav.js'
import { initFileDrop } from './modules/file-drop.js'
import { initMotion } from './modules/motion.js'
import { initSmoothScroll } from './modules/smooth-scroll.js'
import { initScrollProgress } from './modules/scroll-progress.js'
import { initHeadingFill } from './modules/heading-fill.js'
import { initWordFill } from './modules/word-fill.js'
import { initDecode } from './modules/decode.js'
import { initBrandFlow } from './modules/brand-flow.js'
import { initFlow } from './modules/flow.js'
import { initCountUp } from './modules/count-up.js'
import { initPointerDepth } from './modules/pointer-depth.js'
import { initMagnetic } from './modules/magnetic.js'
import { initWikiFilters } from './modules/wiki-filter.js'

initHeader()
initMosaic()
initFilters()
initWikiFilters()
initTabs()
initSliders()
initGoogleReviews()
initMarquees()
initFormPresets()
initJumpNav()
initFileDrop()
initMotion()
initSmoothScroll()
// word fill and brand flow listen to scroll progress: set them up before its first measurement
initWordFill()
initBrandFlow()
initScrollProgress()
initHeadingFill()
initDecode()
initFlow()
initCountUp()
initPointerDepth()
initMagnetic()
